import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/apiClient";

const ANALYTICS_FIELDS = [
  ["ga_measurement_id", "Google Analytics Measurement ID (G-XXXX)"],
  ["gsc_verification", "Google Search Console Verification"],
  ["meta_pixel_id", "Meta Pixel ID"],
];

export default function Settings() {
  const [settings, setSettings] = useState({ analytics: {}, org: {} });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings").then((r) => setSettings({ analytics: {}, org: {}, ...r.data })); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/settings", settings); toast.success("Settings saved"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-xl">
      <h1 className="font-serif-display text-2xl font-bold text-[#111827] mb-6">Site & SEO Settings</h1>

      <div className="border border-slate-200 bg-white p-6">
        <h2 className="font-semibold text-slate-700 mb-4">Analytics & Tracking</h2>
        <p className="text-xs text-slate-400 mb-4">IDs are stored here for future integration. No fake IDs are hard-coded.</p>
        {ANALYTICS_FIELDS.map(([key, label]) => (
          <div key={key} className="mb-4">
            <label className="block text-xs font-semibold text-slate-600 mb-1">{label}</label>
            <input data-testid={`setting-${key}`} className="w-full border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-[#0F2C59]"
              value={settings.analytics?.[key] || ""}
              onChange={(e) => setSettings({ ...settings, analytics: { ...settings.analytics, [key]: e.target.value } })} />
          </div>
        ))}
      </div>

      <div className="border border-slate-200 bg-white p-6 mt-6">
        <h2 className="font-semibold text-slate-700 mb-4">Organization (SEO)</h2>
        {[["site_title", "Default Site Title"], ["default_description", "Default Meta Description"]].map(([key, label]) => (
          <div key={key} className="mb-4">
            <label className="block text-xs font-semibold text-slate-600 mb-1">{label}</label>
            <input className="w-full border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-[#0F2C59]"
              value={settings.org?.[key] || ""}
              onChange={(e) => setSettings({ ...settings, org: { ...settings.org, [key]: e.target.value } })} />
          </div>
        ))}
      </div>

      <button data-testid="settings-save" onClick={save} disabled={saving} className="bg-[#0F2C59] text-white px-6 py-2.5 text-sm font-semibold mt-6 disabled:opacity-50">
        {saving ? "Saving…" : "Save Settings"}
      </button>
    </div>
  );
}
